export default {
  data() {
    return {
      animateSubmitButton: false,
      animatedSubmitError: false,
      animatedSubmitSuccess: false,
    }
  },
  computed: {
    submitClassObject: function () {
      return {
        'error': this.animatedSubmitError,
        'success': this.animatedSubmitSuccess
      }
    }
  },
  methods: {
    enableSubmitAnimation: function (status) {
      this.animateSubmitButton = true;
      if (status) {
        this.animatedSubmitSuccess = true;
        setTimeout(() => {
          this.animatedSubmitSuccess = false;
          this.animateSubmitButton = false;
        }, 2000);
      } else {
        this.animatedSubmitError = true
        setTimeout(() => {
            this.animatedSubmitError = false;
            this.animateSubmitButton = false;
          }, 2000);
      }
    }
  }
}

